import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './CaseBalance.css';
import PageTitle from '../Layout/components/PageTitle';
import {
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Button,
    InputBase,
    Link,
    Dialog,
    Drawer,
    TableFooter,
    TablePagination,
    Breadcrumbs,
    Typography
} from '@material-ui/core';
import Search from '@material-ui/icons/Search'
import SideList from './components/SideList'
import {BASE_URL} from '../../store/config';
import instance from '../../request/http';
import {isRole, ROLES, roleStr, roleName, defaultPageSize, ADD, EDIT, VIEW} from '../../common/common';
import {timeFormat, timeFormatS, localTimeFormatS, toMoney} from '../../common/utils';

import AlertDialog from '../Layout/components/AlertDialog'
import Toast from '../Layout/components/Toast';
import DepositInfo from './components/DepositInfo';

class CaseBalance extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            stateRight: false,
            dialogTitle: "",
            dialogState: ADD,
            dialogData: null,
            showAlert: false,
            caseNumber: "",
            case_id: "",
            totalDeposit: "",
            caseBalance: "",

            client_name: "",
            case_number: "",
            matter_number: "",
            start_date: "",
            end_date: "",
            handler_id: 0,
            handler_office: "",
            handler_team_id: 0,
            handler_department_id: 0,
            balanceData: [],

            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,

            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleModify = this.handleModify.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleDrawer = this.handleDrawer.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAddNewDeposit = this.handleAddNewDeposit.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
    }

    render() {
        const {
            open,
            caseNumber,
            case_id,
            dialogTitle,
            dialogData,
            dialogState,
            balanceData,
            showAlert,
            showToast,
            toastMsg,
            toastState,
            page_index,
            page_size,
            total_items,
            totalDeposit,
            caseBalance,
        } = this.state;
        return (
            <Root>
                <div className="head h h-t">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <Link className="title" href="/main/case">All Cases</Link>
                            <Typography className="crtTitle">{caseNumber} Balance</Typography>
                        </Breadcrumbs>
                    </div>
                    <div className="f h h-r">
                        <Button variant="contained" color="primary" onClick={this.handleAddNewDeposit}>add new
                            Deposit</Button>
                    </div>
                </div>
                <div className="tableTool h">
                    <div className="searchWapper h m-20">
                        <div className="search c">
                            <Search/>
                        </div>
                        <InputBase
                            placeholder="Search payer name"
                            className="bgW"
                            inputProps={{'aria-label': 'Search'}}
                            onChange={e => this.handleSearch(e, 'client_name')}
                        />
                    </div>
                    <div className="textWapper f">
                        <div className="title">TOTAL CHARGE</div>
                        <div className="time">$ {toMoney(totalDeposit*-1)}</div>
                    </div>
                    <div className="textWapper f">
                        <div className="title">CURRENT BALANCE</div>
                        <div className="time">$ {toMoney(caseBalance)}</div>
                    </div>
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Date</TableCell>
                                <TableCell>Action</TableCell>
                                <TableCell>Invoice #</TableCell>
                                <TableCell>$ Amount</TableCell>
                                <TableCell>$ Balance</TableCell>
                                <TableCell>Description</TableCell>
                                {isRole(ROLES.admin)?<TableCell>Operations</TableCell>:""}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {balanceData.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell component="th" scope="row">{this.extractData(row, "time")}</TableCell>
                                    <TableCell>{this.extractData(row, "action")}</TableCell>
                                    <TableCell>{this.extractData(row, "invoice")}</TableCell>
                                    <TableCell>{this.extractData(row, "deposit")}</TableCell>
                                    <TableCell>{this.extractData(row, "balance")}</TableCell>
                                    <TableCell>{this.extractData(row, "desc")}</TableCell>
                                    {isRole(ROLES.admin)?
                                    <TableCell>
                                        {row.action === "manual_add" ? (
                                            <div className="h h-l">
                                                <Button size="small" variant="outlined" color="primary"
                                                        onClick={e => this.handleDepositEdit(e, row)}>Edit</Button>
                                            </div>
                                        ) : ""}
                                    </TableCell>: ""}
                                </TableRow>
                            ))}
                            {balanceData.length === 0 && (
                                <TableRow style={{height: 300}}>
                                    <TableCell colSpan={13}/>
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={13}
                                    count={total_items}
                                    page={balanceData.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: {'arialabel': 'Rows per page'},
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Dialog maxWidth={false} open={open}>
                    <DepositInfo
                        handleCreate={this.handleCreate}
                        handleModify={this.handleModify}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                        caseId={case_id}
                        caseNumber={caseNumber}
                        state={dialogState}
                    ></DepositInfo>
                </Dialog>
                <Drawer anchor="right" open={this.state.stateRight} onClose={e => this.handleDrawer(e, false)}>
                    <div
                        role="presentation"
                    >
                        <SideList
                            handleApply={this.handleApply}
                        ></SideList>
                    </div>
                </Drawer>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this invoice?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }

    componentDidMount() {
        const caseNumber = localStorage.getItem('case_num');
        const case_id = localStorage.getItem('case_id');
        this.setState({
            caseNumber,
            case_id
        }, () => {
            this.getInvoiceData();
        })
    }

    getInvoiceData() {
        const {
            caseNumber,
            page_index,
            page_size,
        } = this.state;
        console.log(typeof caseNumber)
        let params = {
            case_number: caseNumber,
            page_index,
            page_size
        }
        this.getBalance(params);
    }

    handleAddNewDeposit() {
        this.openDialog("ADD DEPOSIT", ADD);
    }

    handleCreate(obj) {
        this.addDeposit(obj.date, obj.description, obj.amount);
    }

    handleModify(obj) {
        console.log(obj);
        this.setDeposit(obj.id, obj.description, obj.amount);
    }

    handleDepositEdit(e, obj) {
        console.log(obj);
        this.setState(() => ({
            dialogData: obj
        }))
        this.openDialog("EDIT DIRECT DEPOSIT", EDIT);
    }

    handleView(e, obj) {
        console.log(obj);
        this.setState(() => ({
            dialogData: obj
        }))
        this.openDialog("VIEW DEPOSIT", VIEW);
    }

    handleEdit(e, obj) {
        this.setState(() => ({
            dialogData: obj,
        }))
        this.toInvoiceInfo(obj, EDIT);
    }

    handleDel(e, obj) {
        this.crtInvoiceId = obj.id;
        this.setState(() => ({
            showAlert: true
        }));
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }

    handleAlertYes() {
        this.delInvoice(this.crtInvoiceId);
        this.setState(() => ({
            showAlert: false
        }));
    }

    handleAlertNo() {
        this.setState(() => ({
            showAlert: false
        }));
    }

    handleCloseDialog() {
        this.getInvoiceData();
        this.closeDialog();
    }

    handleSearch(e, name) {
        const value = e.target.value;
        if (name === "number") {
            this.setState({
                case_number: value,
                matter_number: value,
                page_index: 1
            }, () => {
                this.getInvoiceData();
            })
        } else if (name === "client_name") {
            this.setState({
                client_name: value,
                page_index: 1
            }, () => {
                this.getInvoiceData();
            })
        }
    }

    handleApply(obj) {
        console.log(obj)
        this.setState({
            page_index: 1,
            drawerOpen: false,
        }, () => {
            this.getInvoiceData();
        })
    }

    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getInvoiceData();
        })
    }

    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getInvoiceData();
        });
    }

    handleDrawer(e, open) {
        this.setState(() => ({
            stateRight: open
        }));
    };

    handleCancel() {
        this.closeDialog();
    }

    closeDialog() {
        this.setState(() => ({
            open: false,
            dialogData: null,
        }));
    }

    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state,
        }));
    }

    extractData(row, name) {
        if (name === "time") {
            const time = row.action_time;
            return localTimeFormatS(time);
        } else if (name === "invoice") {
            if (!row.invoice) return "--";
            return row.invoice.number;
        } else if (name === "action") {
            return row.action;
        } else if (name === "deposit") {
            let sign = '+';
            if (row.amount < 0) {
                row.amount = row.amount * -1;
                sign = '-';
            }
            let depositAmount = toMoney(row.amount);
            return sign + " $ " + depositAmount;
        } else if (name === "balance") {
            return "$ " + toMoney(row.case_balance);
        } else if (name === "desc") {
            return row.description;
        }
    }

    // extractData(row, name) {
    //     if (name === "time") {
    //         if (!row.deposite) return "--";
    //         const time = row.deposite.create_time;
    //         return localTimeFormatS(time);
    //     } else if (name === "invoice") {
    //         if (!row.invoice) return "--";
    //         return row.invoice.number;
    //     } else if (name === "email") {
    //         if (!row.invoice) return "--";
    //         return row.invoice.contact_email;
    //     } else if (name === "deposit") {
    //         if (!row.invoice) return "--";
    //         if (!row.deposite) return "--";
    //         const depositAmount = "$ " + toMoney(row.deposite.amount);
    //         return depositAmount;
    //     }
    // }
    //---------------request---------------
    getBalance(params) {
        instance.get(BASE_URL + 'case/balance/history', {params}).then((res) => {
            const data = res.data.data;
            const balanceData = data.history;
            const caseBalance = data.case_balance;
            const totalDeposit = data.total_deposite;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(data)
            this.setState(() => ({
                balanceData,
                caseBalance,
                totalDeposit,
                page_size,
                total_items,
            }));
        }).catch((err) => {
            console.log(err)
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }

    addDeposit(date, description, amount) {
        const {case_id} = this.state;
        const params = {
            amount: Number(amount),
            date: (Date.parse(date) / 1000).toString(),
            description,
        }
        instance.post(BASE_URL + 'case/' + case_id + '/balance', params).then((res) => {
            this.closeDialog();
            this.getInvoiceData();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    setDeposit(id, description, amount) {
        const params = {
            amount: Number(amount),
            description,
        }
        instance.put(BASE_URL + 'admin/case/history/' + id, params).then((res) => {
            this.closeDialog();
            this.getInvoiceData();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default withRouter(CaseBalance);